export const ArpeggioKeysCard = props => {


  return (
    
    <div className="arpeggioKeysContainer">
      <div className="soundsTxt">Sounds</div>
      <div className="drumsTxt">Drums</div>
      <div className="instrumentsKeysContainer" data-action="playSingleSound">
        <div className="arpeggioKeyBtn arpeggioInstrumentsKeyBtn pointerHover" id="arpeggioKey1"  data-note="1" title="A" onClick={props.handleClick}>
          A
        </div>
        <div className="arpeggioKeyBtn arpeggioInstrumentsKeyBtn pointerHover" id="arpeggioKey2"  data-note="2" title="S" onClick={props.handleClick}>
          S
        </div>
        <div className="arpeggioKeyBtn arpeggioInstrumentsKeyBtn pointerHover" id="arpeggioKey3"  data-note="3" title="D" onClick={props.handleClick}>
          D
        </div>
        <div className="arpeggioKeyBtn arpeggioInstrumentsKeyBtn pointerHover" id="arpeggioKey4"  data-note="4" title="F" onClick={props.handleClick}>
          F
        </div>
        <div className="arpeggioKeyBtn arpeggioInstrumentsKeyBtn pointerHover" id="arpeggioKey5"  data-note="5" title="G" onClick={props.handleClick}>
          G
        </div>
        <div className="arpeggioKeyBtn arpeggioInstrumentsKeyBtn pointerHover" id="arpeggioKey6"  data-note="6" title="H" onClick={props.handleClick}>
          H
        </div>
      </div>
      <div className="emptySpaceKeysContainer">

      </div>
      <div className="drumsKeysContainer" data-action="playSingleSound">
        <div className="arpeggioKeyBtn arpeggioDrumsKeyBtn pointerHover" id="arpeggioKey7"  data-note="7" title="J" onClick={props.handleClick}>
          J
        </div>
        <div className="arpeggioKeyBtn arpeggioDrumsKeyBtn pointerHover" id="arpeggioKey8"  data-note="8" title="K" onClick={props.handleClick}>
          K
        </div>
        <div className="arpeggioKeyBtn arpeggioDrumsKeyBtn pointerHover" id="arpeggioKey9"  data-note="9" title="L" onClick={props.handleClick}>
          L
        </div>
      </div>

    </div>
  )
}